const externalSourceReferenceOption = {
  projectOptions: [
    {
      searchValue: '<no selection>',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.project.none',
        defaultMessage: 'Not applicable',
      },
    },
  ],
  tcga_normalOptions: [
    {
      searchValue: '<no selection>',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaNormal.none',
        defaultMessage: 'Select an option...',
      },
    },
    {
      searchValue: 'All Diseases/Tissues [*] (727)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaNormal.all',
        defaultMessage: 'All Diseases/Tissues [*] (727)',
      },
    },
    {
      searchValue: 'bladder urothelial carcinoma [BLCA] (19)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaNormal.blca',
        defaultMessage: 'Bladder urothelial carcinoma [BLCA] (19)',
      },
    },
    {
      searchValue: 'breast invasive carcinoma [BRCA] (113)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaNormal.brca',
        defaultMessage: 'Breast invasive carcinoma [BRCA] (113)',
      },
    },
    {
      searchValue: 'cervical & endocervical cancer [CESC] (3)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaNormal.cesc',
        defaultMessage: 'Cervical & endocervical cancer [CESC] (3)',
      },
    },
    {
      searchValue: 'cholangiocarcinoma [CHOL] (9)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaNormal.chol',
        defaultMessage: 'Cholangiocarcinoma [CHOL] (9)',
      },
    },
    {
      searchValue: 'colon adenocarcinoma [COAD] (41)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaNormal.coad',
        defaultMessage: 'Colon adenocarcinoma [COAD] (41)',
      },
    },
    {
      searchValue: 'esophageal carcinoma [ESCA] (13)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaNormal.esca',
        defaultMessage: 'Esophageal carcinoma [ESCA] (13)',
      },
    },
    {
      searchValue: 'glioblastoma multiforme [GBM] (5)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaNormal.gbm',
        defaultMessage: 'Glioblastoma multiforme [GBM] (5)',
      },
    },
    {
      searchValue: 'head & neck squamous cell carcinoma [HNSC] (44)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaNormal.hnsc',
        defaultMessage: 'Head & neck squamous cell carcinoma [HNSC] (44)',
      },
    },
    {
      searchValue: 'kidney chromophobe [KICH] (25)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaNormal.kich',
        defaultMessage: 'Kidney chromophobe [KICH] (25)',
      },
    },
    {
      searchValue: 'kidney clear cell carcinoma [KIRC] (72)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaNormal.kirc',
        defaultMessage: 'Kidney clear cell carcinoma [KIRC] (72)',
      },
    },
    {
      searchValue: 'kidney papillary cell carcinoma [KIRP] (32)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaNormal.kirp',
        defaultMessage: 'Kidney papillary cell carcinoma [KIRP] (32)',
      },
    },
    {
      searchValue: 'liver hepatocellular carcinoma [LIHC] (50)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaNormal.lihc',
        defaultMessage: 'Liver hepatocellular carcinoma [LIHC] (50)',
      },
    },
    {
      searchValue: 'lung adenocarcinoma [LUAD] (59)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaNormal.luad',
        defaultMessage: 'Lung adenocarcinoma [LUAD] (59)',
      },
    },
    {
      searchValue: 'lung squamous cell carcinoma [LUSC] (50)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaNormal.lusc',
        defaultMessage: 'Lung squamous cell carcinoma [LUSC] (50)',
      },
    },
    {
      searchValue: 'pancreatic adenocarcinoma [PAAD] (4)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaNormal.paad',
        defaultMessage: 'Pancreatic adenocarcinoma [PAAD] (4)',
      },
    },
    {
      searchValue: 'pheochromocytoma & paraganglioma [PCPG] (3)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaNormal.pcpg',
        defaultMessage: 'Pheochromocytoma & paraganglioma [PCPG] (3)',
      },
    },
    {
      searchValue: 'prostate adenocarcinoma [PRAD] (52)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaNormal.prad',
        defaultMessage: 'Prostate adenocarcinoma [PRAD] (52)',
      },
    },
    {
      searchValue: 'rectum adenocarcinoma [READ] (10)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaNormal.read',
        defaultMessage: 'Rectum adenocarcinoma [READ] (10)',
      },
    },
    {
      searchValue: 'sarcoma [SARC] (2)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaNormal.sarc',
        defaultMessage: 'Sarcoma [SARC] (2)',
      },
    },
    {
      searchValue: 'skin cutaneous melanoma [SKCM] (1)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaNormal.skcm',
        defaultMessage: 'Skin cutaneous melanoma [SKCM] (1)',
      },
    },
    {
      searchValue: 'stomach adenocarcinoma [STAD] (36)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaNormal.stad',
        defaultMessage: 'Stomach adenocarcinoma [STAD] (36)',
      },
    },
    {
      searchValue: 'thymoma [THYM] (2)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaNormal.thym',
        defaultMessage: 'Thymoma [THYM] (2)',
      },
    },
    {
      searchValue: 'thyroid carcinoma [THCA] (59)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaNormal.thca',
        defaultMessage: 'Thyroid carcinoma [THCA] (59)',
      },
    },
    {
      searchValue: 'uterine corpus endometrioid carcinoma [UCEC] (23)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaNormal.ucec',
        defaultMessage: 'Uterine corpus endometrioid carcinoma [UCEC] (23)',
      },
    },
  ],
  tcga_tumorOptions: [
    {
      searchValue: '<no selection>',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaTumor.none',
        defaultMessage: 'Select an option...',
      },
    },
    {
      searchValue: 'All Diseases/Tissues [*] (9359)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaTumor.all',
        defaultMessage: 'All Diseases/Tissues [*] (9359)',
      },
    },
    {
      searchValue: 'acute myeloid leukemia [LAML] (173)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaTumor.laml',
        defaultMessage: 'Acute myeloid leukemia [LAML] (173)',
      },
    },
    {
      searchValue: 'adrenocortical cancer [ACC] (77)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaTumor.acc',
        defaultMessage: 'Adrenocortical cancer [ACC] (77)',
      },
    },
    {
      searchValue: 'bladder urothelial carcinoma [BLCA] (407)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaTumor.blca',
        defaultMessage: 'Bladder urothelial carcinoma [BLCA] (407)',
      },
    },
    {
      searchValue: 'brain lower grade glioma [LGG] (509)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaTumor.lgg',
        defaultMessage: 'Brain lower grade glioma [LGG] (509)',
      },
    },
    {
      searchValue: 'breast invasive carcinoma [BRCA] (1092)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaTumor.brca',
        defaultMessage: 'Breast invasive carcinoma [BRCA] (1092)',
      },
    },
    {
      searchValue: 'cervical & endocervical cancer [CESC] (304)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaTumor.cesc',
        defaultMessage: 'Cervical & endocervical cancer [CESC] (304)',
      },
    },
    {
      searchValue: 'cholangiocarcinoma [CHOL] (36)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaTumor.chol',
        defaultMessage: 'Cholangiocarcinoma [CHOL] (36)',
      },
    },
    {
      searchValue: 'colon adenocarcinoma [COAD] (288)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaTumor.coad',
        defaultMessage: 'Colon adenocarcinoma [COAD] (288)',
      },
    },
    {
      searchValue: 'diffuse large B-cell lymphoma [DLBC] (47)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaTumor.dlbc',
        defaultMessage: 'Diffuse large B-cell lymphoma [DLBC] (47)',
      },
    },
    {
      searchValue: 'esophageal carcinoma [ESCA] (181)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaTumor.esca',
        defaultMessage: 'Esophageal carcinoma [ESCA] (181)',
      },
    },
    {
      searchValue: 'glioblastoma multiforme [GBM] (153)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaTumor.gbm',
        defaultMessage: 'Glioblastoma multiforme [GBM] (153)',
      },
    },
    {
      searchValue: 'head & neck squamous cell carcinoma [HNSC] (518)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaTumor.hnsc',
        defaultMessage: 'Head & neck squamous cell carcinoma [HNSC] (518)',
      },
    },
    {
      searchValue: 'kidney chromophobe [KICH] (66)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaTumor.kich',
        defaultMessage: 'Kidney chromophobe [KICH] (66)',
      },
    },
    {
      searchValue: 'kidney clear cell carcinoma [KIRC] (530)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaTumor.kirc',
        defaultMessage: 'Kidney clear cell carcinoma [KIRC] (530)',
      },
    },
    {
      searchValue: 'kidney papillary cell carcinoma [KIRP] (288)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaTumor.kirp',
        defaultMessage: 'Kidney papillary cell carcinoma [KIRP] (288)',
      },
    },
    {
      searchValue: 'liver hepatocellular carcinoma [LIHC] (369)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaTumor.lihc',
        defaultMessage: 'Liver hepatocellular carcinoma [LIHC] (369)',
      },
    },
    {
      searchValue: 'lung adenocarcinoma [LUAD] (513)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaTumor.luad',
        defaultMessage: 'Lung adenocarcinoma [LUAD] (513)',
      },
    },
    {
      searchValue: 'lung squamous cell carcinoma [LUSC] (498)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaTumor.lusc',
        defaultMessage: 'Lung squamous cell carcinoma [LUSC] (498)',
      },
    },
    {
      searchValue: 'mesothelioma [MESO] (87)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaTumor.meso',
        defaultMessage: 'Mesothelioma [MESO] (87)',
      },
    },
    {
      searchValue: 'ovarian serous cystadenocarcinoma [OV] (420)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaTumor.ov',
        defaultMessage: 'Ovarian serous cystadenocarcinoma [OV] (420)',
      },
    },
    {
      searchValue: 'pancreatic adenocarcinoma [PAAD] (178)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaTumor.paad',
        defaultMessage: 'Pancreatic adenocarcinoma [PAAD] (178)',
      },
    },
    {
      searchValue: 'pheochromocytoma & paraganglioma [PCPG] (177)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaTumor.pcpg',
        defaultMessage: 'Pheochromocytoma & paraganglioma [PCPG] (177)',
      },
    },
    {
      searchValue: 'prostate adenocarcinoma [PRAD] (495)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaTumor.prad',
        defaultMessage: 'Prostate adenocarcinoma [PRAD] (495)',
      },
    },
    {
      searchValue: 'rectum adenocarcinoma [READ] (92)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaTumor.read',
        defaultMessage: 'Rectum adenocarcinoma [READ] (92)',
      },
    },
    {
      searchValue: 'sarcoma [SARC] (258)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaTumor.sarc',
        defaultMessage: 'Sarcoma [SARC] (258)',
      },
    },
    {
      searchValue: 'skin cutaneous melanoma [SKCM] (102)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaTumor.skcm',
        defaultMessage: 'Skin cutaneous melanoma [SKCM] (102)',
      },
    },
    {
      searchValue: 'stomach adenocarcinoma [STAD] (414)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaTumor.stad',
        defaultMessage: 'Stomach adenocarcinoma [STAD] (414)',
      },
    },
    {
      searchValue: 'testicular germ cell tumor [TGCT] (148)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaTumor.tgct',
        defaultMessage: 'Testicular germ cell tumor [TGCT] (148)',
      },
    },
    {
      searchValue: 'thymoma [THYM] (119)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaTumor.thym',
        defaultMessage: 'Thymoma [THYM] (119)',
      },
    },
    {
      searchValue: 'thyroid carcinoma [THCA] (504)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaTumor.thca',
        defaultMessage: 'Thyroid carcinoma [THCA] (504)',
      },
    },
    {
      searchValue: 'uterine carcinosarcoma [UCS] (57)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaTumor.ucs',
        defaultMessage: 'Uterine carcinosarcoma [UCS] (57)',
      },
    },
    {
      searchValue: 'uterine corpus endometrioid carcinoma [UCEC] (180)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaTumor.ucec',
        defaultMessage: 'Uterine corpus endometrioid carcinoma [UCEC] (180)',
      },
    },
    {
      searchValue: 'uveal melanoma [UVM] (79)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.tcgaTumor.uvm',
        defaultMessage: 'Uveal melanoma [UVM] (79)',
      },
    },
  ],
  gtex_broadOptions: [
    {
      searchValue: '<no selection>',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexBroad.none',
        defaultMessage: 'Select an option...',
      },
    },
    {
      searchValue: 'All Diseases/Tissues (17382)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexBroad.all',
        defaultMessage: 'All Diseases/Tissues (17382)',
      },
    },
    {
      searchValue: 'Adipose Tissue (1204)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexBroad.tissue',
        defaultMessage: 'Adipose Tissue (1204)',
      },
    },
    {
      searchValue: 'Adrenal Gland (258)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexBroad.glandBroad',
        defaultMessage: 'Adrenal Gland (258)',
      },
    },
    {
      searchValue: 'Bladder (21)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexBroad.bladder',
        defaultMessage: 'Bladder (21)',
      },
    },
    {
      searchValue: 'Blood (929)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexBroad.blood',
        defaultMessage: 'Blood (929)',
      },
    },
    {
      searchValue: 'Blood Vessel (1335)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexBroad.vessel',
        defaultMessage: 'Blood Vessel (1335)',
      },
    },
    {
      searchValue: 'Brain (2642)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexBroad.brain',
        defaultMessage: 'Brain (2642)',
      },
    },
    {
      searchValue: 'Breast (459)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexBroad.breast',
        defaultMessage: 'Breast (459)',
      },
    },
    {
      searchValue: 'Cervix Uteri (19)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexBroad.uteri',
        defaultMessage: 'Cervix Uteri (19)',
      },
    },
    {
      searchValue: 'Colon (779)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexBroad.colon',
        defaultMessage: 'Colon (779)',
      },
    },
    {
      searchValue: 'Esophagus (1445)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexBroad.esophagus',
        defaultMessage: 'Esophagus (1445)',
      },
    },
    {
      searchValue: 'Fallopian Tube (9)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexBroad.tube',
        defaultMessage: 'Fallopian Tube (9)',
      },
    },
    {
      searchValue: 'Heart (861)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexBroad.heart',
        defaultMessage: 'Heart (861)',
      },
    },
    {
      searchValue: 'Kidney (89)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexBroad.kidney',
        defaultMessage: 'Kidney (89)',
      },
    },
    {
      searchValue: 'Liver (226)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexBroad.liver',
        defaultMessage: 'Liver (226)',
      },
    },
    {
      searchValue: 'Lung (578)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexBroad.lung',
        defaultMessage: 'Lung (578)',
      },
    },
    {
      searchValue: 'Muscle (803)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexBroad.muscle',
        defaultMessage: 'Muscle (803)',
      },
    },
    {
      searchValue: 'Nerve (619)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexBroad.nerve',
        defaultMessage: 'Nerve (619)',
      },
    },
    {
      searchValue: 'Ovary (180)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexBroad.ovary',
        defaultMessage: 'Ovary (180)',
      },
    },
    {
      searchValue: 'Pancreas (328)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexBroad.pancreas',
        defaultMessage: 'Pancreas (328)',
      },
    },
    {
      searchValue: 'Pituitary (283)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexBroad.pituitary',
        defaultMessage: 'Pituitary (283)',
      },
    },
    {
      searchValue: 'Prostate (245)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexBroad.prostate',
        defaultMessage: 'Prostate (245)',
      },
    },
    {
      searchValue: 'Salivary Gland (162)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexBroad.gland',
        defaultMessage: 'Salivary Gland (162)',
      },
    },
    {
      searchValue: 'Skin (1809)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexBroad.skin',
        defaultMessage: 'Skin (1809)',
      },
    },
    {
      searchValue: 'Small Intestine (187)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexBroad.intestine',
        defaultMessage: 'Small Intestine (187)',
      },
    },
    {
      searchValue: 'Spleen (241)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexBroad.spleen',
        defaultMessage: 'Spleen (241)',
      },
    },
    {
      searchValue: 'Stomach (359)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexBroad.stomach',
        defaultMessage: 'Stomach (359)',
      },
    },
    {
      searchValue: 'Testis (361)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexBroad.testis',
        defaultMessage: 'Testis (361)',
      },
    },
    {
      searchValue: 'Thyroid (653)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexBroad.thyroid',
        defaultMessage: 'Thyroid (653)',
      },
    },
    {
      searchValue: 'Uterus (142)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexBroad.uterus',
        defaultMessage: 'Uterus (142)',
      },
    },
    {
      searchValue: 'Vagina (156)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexBroad.vagina',
        defaultMessage: 'Vagina (156)',
      },
    },
  ],
  gtex_specificOptions: [
    {
      searchValue: '<no selection>',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexSpecific.none',
        defaultMessage: 'Select an option...',
      },
    },
    {
      searchValue: 'All Diseases/Tissues (17382)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexSpecific.all',
        defaultMessage: 'All Diseases/Tissues (17382)',
      },
    },
    {
      searchValue: 'Adipose - Subcutaneous (663)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexSpecific.subcutaneous',
        defaultMessage: 'Adipose - Subcutaneous (663)',
      },
    },
    {
      searchValue: 'Adipose - Visceral (Omentum) (541)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexSpecific.(omentum)',
        defaultMessage: 'Adipose - Visceral (Omentum) (541)',
      },
    },
    {
      searchValue: 'Adrenal Gland (258)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexSpecific.gland',
        defaultMessage: 'Adrenal Gland (258)',
      },
    },
    {
      searchValue: 'Artery - Aorta (432)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexSpecific.aorta',
        defaultMessage: 'Artery - Aorta (432)',
      },
    },
    {
      searchValue: 'Artery - Coronary (240)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexSpecific.coronary',
        defaultMessage: 'Artery - Coronary (240)',
      },
    },
    {
      searchValue: 'Artery - Tibial (663)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexSpecific.tibial',
        defaultMessage: 'Artery - Tibial (663)',
      },
    },
    {
      searchValue: 'Bladder (21)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexSpecific.bladder',
        defaultMessage: 'Bladder (21)',
      },
    },
    {
      searchValue: 'Brain - Amygdala (152)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexSpecific.amygdala',
        defaultMessage: 'Brain - Amygdala (152)',
      },
    },
    {
      searchValue: 'Brain - Anterior cingulate cortex (BA24) (176)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexSpecific.(ba24)',
        defaultMessage: 'Brain - Anterior cingulate cortex (BA24) (176)',
      },
    },
    {
      searchValue: 'Brain - Caudate (basal ganglia) (246)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexSpecific.ganglia)',
        defaultMessage: 'Brain - Caudate (basal ganglia) (246)',
      },
    },
    {
      searchValue: 'Brain - Cerebellar Hemisphere (215)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexSpecific.hemisphere',
        defaultMessage: 'Brain - Cerebellar Hemisphere (215)',
      },
    },
    {
      searchValue: 'Brain - Cerebellum (241)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexSpecific.cerebellum',
        defaultMessage: 'Brain - Cerebellum (241)',
      },
    },
    {
      searchValue: 'Brain - Cortex (255)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexSpecific.cortex',
        defaultMessage: 'Brain - Cortex (255)',
      },
    },
    {
      searchValue: 'Brain - Frontal Cortex (BA9) (209)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexSpecific.(ba9)',
        defaultMessage: 'Brain - Frontal Cortex (BA9) (209)',
      },
    },
    {
      searchValue: 'Brain - Hippocampus (197)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexSpecific.hippocampus',
        defaultMessage: 'Brain - Hippocampus (197)',
      },
    },
    {
      searchValue: 'Brain - Hypothalamus (202)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexSpecific.hypothalamus',
        defaultMessage: 'Brain - Hypothalamus (202)',
      },
    },
    {
      searchValue: 'Brain - Nucleus accumbens (basal ganglia) (246)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexSpecific.ganglia)',
        defaultMessage: 'Brain - Nucleus accumbens (basal ganglia) (246)',
      },
    },
    {
      searchValue: 'Brain - Putamen (basal ganglia) (205)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexSpecific.ganglia)',
        defaultMessage: 'Brain - Putamen (basal ganglia) (205)',
      },
    },
    {
      searchValue: 'Brain - Spinal cord (cervical c-1) (159)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexSpecific.c-1)',
        defaultMessage: 'Brain - Spinal cord (cervical c-1) (159)',
      },
    },
    {
      searchValue: 'Brain - Substantia nigra (139)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexSpecific.nigra',
        defaultMessage: 'Brain - Substantia nigra (139)',
      },
    },
    {
      searchValue: 'Breast - Mammary Tissue (459)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexSpecific.tissue',
        defaultMessage: 'Breast - Mammary Tissue (459)',
      },
    },
    {
      searchValue: 'Cells - Cultured fibroblasts (504)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexSpecific.fibroblasts',
        defaultMessage: 'Cells - Cultured fibroblasts (504)',
      },
    },
    {
      searchValue: 'Cells - EBV-transformed lymphocytes (174)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexSpecific.lymphocytes',
        defaultMessage: 'Cells - EBV-transformed lymphocytes (174)',
      },
    },
    {
      searchValue: 'Cervix - Ectocervix (9)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexSpecific.ectocervix',
        defaultMessage: 'Cervix - Ectocervix (9)',
      },
    },
    {
      searchValue: 'Cervix - Endocervix (10)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexSpecific.endocervix',
        defaultMessage: 'Cervix - Endocervix (10)',
      },
    },
    {
      searchValue: 'Colon - Sigmoid (373)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexSpecific.sigmoid',
        defaultMessage: 'Colon - Sigmoid (373)',
      },
    },
    {
      searchValue: 'Colon - Transverse (406)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexSpecific.transverse',
        defaultMessage: 'Colon - Transverse (406)',
      },
    },
    {
      searchValue: 'Esophagus - Gastroesophageal Junction (375)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexSpecific.junction',
        defaultMessage: 'Esophagus - Gastroesophageal Junction (375)',
      },
    },
    {
      searchValue: 'Esophagus - Mucosa (555)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexSpecific.mucosa',
        defaultMessage: 'Esophagus - Mucosa (555)',
      },
    },
    {
      searchValue: 'Esophagus - Muscularis (515)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexSpecific.muscularis',
        defaultMessage: 'Esophagus - Muscularis (515)',
      },
    },
    {
      searchValue: 'Fallopian Tube (9)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexSpecific.tube',
        defaultMessage: 'Fallopian Tube (9)',
      },
    },
    {
      searchValue: 'Heart - Atrial Appendage (429)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexSpecific.appendage',
        defaultMessage: 'Heart - Atrial Appendage (429)',
      },
    },
    {
      searchValue: 'Heart - Left Ventricle (432)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexSpecific.ventricle',
        defaultMessage: 'Heart - Left Ventricle (432)',
      },
    },
    {
      searchValue: 'Kidney - Cortex (85)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexSpecific.cortex',
        defaultMessage: 'Kidney - Cortex (85)',
      },
    },
    {
      searchValue: 'Kidney - Medulla (4)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexSpecific.medulla',
        defaultMessage: 'Kidney - Medulla (4)',
      },
    },
    {
      searchValue: 'Liver (226)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexSpecific.liver',
        defaultMessage: 'Liver (226)',
      },
    },
    {
      searchValue: 'Lung (578)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexSpecific.lung',
        defaultMessage: 'Lung (578)',
      },
    },
    {
      searchValue: 'Minor Salivary Gland (162)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexSpecific.gland',
        defaultMessage: 'Minor Salivary Gland (162)',
      },
    },
    {
      searchValue: 'Muscle - Skeletal (803)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexSpecific.skeletal',
        defaultMessage: 'Muscle - Skeletal (803)',
      },
    },
    {
      searchValue: 'Nerve - Tibial (619)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexSpecific.tibial',
        defaultMessage: 'Nerve - Tibial (619)',
      },
    },
    {
      searchValue: 'Ovary (180)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexSpecific.ovary',
        defaultMessage: 'Ovary (180)',
      },
    },
    {
      searchValue: 'Pancreas (328)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexSpecific.pancreas',
        defaultMessage: 'Pancreas (328)',
      },
    },
    {
      searchValue: 'Pituitary (283)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexSpecific.pituitary',
        defaultMessage: 'Pituitary (283)',
      },
    },
    {
      searchValue: 'Prostate (245)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexSpecific.prostate',
        defaultMessage: 'Prostate (245)',
      },
    },
    {
      searchValue: 'Skin - Not Sun Exposed (Suprapubic) (604)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexSpecific.(suprapubic)',
        defaultMessage: 'Skin - Not Sun Exposed (Suprapubic) (604)',
      },
    },
    {
      searchValue: 'Skin - Sun Exposed (Lower leg) (701)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexSpecific.leg)',
        defaultMessage: 'Skin - Sun Exposed (Lower leg) (701)',
      },
    },
    {
      searchValue: 'Small Intestine - Terminal Ileum (187)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexSpecific.ileum',
        defaultMessage: 'Small Intestine - Terminal Ileum (187)',
      },
    },
    {
      searchValue: 'Spleen (241)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexSpecific.spleen',
        defaultMessage: 'Spleen (241)',
      },
    },
    {
      searchValue: 'Stomach (359)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexSpecific.stomach',
        defaultMessage: 'Stomach (359)',
      },
    },
    {
      searchValue: 'Testis (361)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexSpecific.testis',
        defaultMessage: 'Testis (361)',
      },
    },
    {
      searchValue: 'Thyroid (653)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexSpecific.thyroid',
        defaultMessage: 'Thyroid (653)',
      },
    },
    {
      searchValue: 'Uterus (142)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexSpecific.uterus',
        defaultMessage: 'Uterus (142)',
      },
    },
    {
      searchValue: 'Vagina (156)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexSpecific.vagina',
        defaultMessage: 'Vagina (156)',
      },
    },
    {
      searchValue: 'Whole Blood (755)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.gtexSpecific.blood',
        defaultMessage: 'Whole Blood (755)',
      },
    },
  ],
  tree_houseOptions: [
    {
      searchValue: '<no selection>',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.treeHouse.none',
        defaultMessage: 'Select an option...',
      },
    },
    {
      searchValue: 'All Diseases/Tissues (2831)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.treeHouse.all',
        defaultMessage: 'All Diseases/Tissues (2831)',
      },
    },
    {
      searchValue: 'acute leukemia (10)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.treeHouse.acuteLeukemia',
        defaultMessage: 'Acute leukemia (10)',
      },
    },
    {
      searchValue: 'acute lymphoblastic leukemia (878)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.treeHouse.acuteLymphoblasticLeukemia',
        defaultMessage: 'Acute lymphoblastic leukemia (878)',
      },
    },
    {
      searchValue: 'acute myeloid leukemia (365)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.treeHouse.acuteMyeloidLeukemia',
        defaultMessage: 'Acute myeloid leukemia (365)',
      },
    },
    {
      searchValue: 'adrenocortical carcinoma (19)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.treeHouse.adrenocorticalCarcinoma',
        defaultMessage: 'Adrenocortical carcinoma (19)',
      },
    },
    {
      searchValue: 'alveolar rhabdomyosarcoma (49)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.treeHouse.alveolarRhabdomyosarcoma',
        defaultMessage: 'Alveolar rhabdomyosarcoma (49)',
      },
    },
    {
      searchValue: 'choroid plexus carcinoma (26)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.treeHouse.choroidPlexusCarcinoma',
        defaultMessage: 'choroid plexus carcinoma (26)',
      },
    },
    {
      searchValue: 'desmoplastic small round cell tumor (8)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.treeHouse.desmoplasticSmallRoundCellTumor',
        defaultMessage: 'Desmoplastic small round cell tumor (8)',
      },
    },
    {
      searchValue: 'dysembryoplastic neuroepithelial tumor (14)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.treeHouse.dysembryoplasticNeuroepithelialTumor',
        defaultMessage: 'Dysembryoplastic neuroepithelial tumor (14)',
      },
    },
    {
      searchValue: 'embryonal rhabdomyosarcoma (61)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.treeHouse.embryonalRhabdomyosarcoma',
        defaultMessage: 'Embryonal rhabdomyosarcoma (61)',
      },
    },
    {
      searchValue: 'ependymoma (102)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.treeHouse.ependymoma',
        defaultMessage: 'Ependymoma (102)',
      },
    },
    {
      searchValue: 'Ewing sarcoma (85)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.treeHouse.ewingSarcoma',
        defaultMessage: 'Ewing sarcoma (85)',
      },
    },
    {
      searchValue: 'fibrolamellar hepatocellular carcinoma (5)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.treeHouse.fibrolamellarHepatocellularCarcinoma',
        defaultMessage: 'Fibrolamellar hepatocellular carcinoma (5)',
      },
    },
    {
      searchValue: 'gastrointestinal stromal tumor (7)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.treeHouse.gastrointestinalStromalTumor',
        defaultMessage: 'Gastrointestinal stromal tumor (7)',
      },
    },
    {
      searchValue: 'glioblastoma multiforme (34)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.treeHouse.glioblastomaMultiforme',
        defaultMessage: 'Glioblastoma multiforme (34)',
      },
    },
    {
      searchValue: 'glioma (215)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.treeHouse.glioma',
        defaultMessage: 'Glioma (215)',
      },
    },
    {
      searchValue: 'hepatoblastoma (19)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.treeHouse.hepatoblastoma',
        defaultMessage: 'Hepatoblastoma (19)',
      },
    },
    {
      searchValue: 'hepatocellular carcinoma (7)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.treeHouse.hepatocellularCarcinoma',
        defaultMessage: 'Hepatocellular carcinoma (7)',
      },
    },
    {
      searchValue: 'lymphoma (50)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.treeHouse.lymphoma',
        defaultMessage: 'Lymphoma (50)',
      },
    },
    {
      searchValue: 'medulloblastoma (125)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.treeHouse.medulloblastoma',
        defaultMessage: 'Medulloblastoma (125)',
      },
    },
    {
      searchValue: 'melanoma (7)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.treeHouse.melanoma',
        defaultMessage: 'Melanoma (7)',
      },
    },
    {
      searchValue: 'neuroblastoma (201)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.treeHouse.neuroblastoma',
        defaultMessage: 'Neuroblastoma (201)',
      },
    },
    {
      searchValue: 'osteosarcoma (189)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.treeHouse.osteosarcoma',
        defaultMessage: 'Osteosarcoma (189)',
      },
    },
    {
      searchValue: 'rhabdomyosarcoma (57)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.treeHouse.rhabdomyosarcoma',
        defaultMessage: 'Rhabdomyosarcoma (57)',
      },
    },
    {
      searchValue: 'spindle cell/sclerosing rhabdomyosarcoma (5)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.treeHouse.spindleCellSclerosingRhabdomyosarcoma',
        defaultMessage: 'Spindle cell/sclerosing rhabdomyosarcoma (5)',
      },
    },
    {
      searchValue: 'supratentorial embryonal tumor NOS (19)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.treeHouse.supratentorialEmbryonalTumor',
        defaultMessage: 'Supratentorial embryonal tumor NOS (19)',
      },
    },
    {
      searchValue: 'synovial sarcoma (31)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.treeHouse.synovialSarcoma',
        defaultMessage: 'Synovial sarcoma (31)',
      },
    },
    {
      searchValue: 'undifferentiated sarcoma NOS (13)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.treeHouse.undifferentiatedSarcoma',
        defaultMessage: 'Undifferentiated sarcoma NOS (13)',
      },
    },
    {
      searchValue: 'wilms tumor (137)',
      intlLabel: {
        id: 'omicsExplorer.filters.geneOutlier.treeHouse.wilmsTumor',
        defaultMessage: 'Wilms tumor (137)',
      },
    },
  ],
};

export { externalSourceReferenceOption };
